/**
 * Project panel
 * Title.js
 * Created by stefensuhat on 2018-11-29 14:03
 */

import { Box, makeStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = { actions: PropTypes.array, title: PropTypes.string.isRequired };
const defaultProps = { actions: [] };

const styles = makeStyles(({ spacing }) => ({
    root: {
        // background: sample(color),
        // borderRadius: shape.borderRadius,
        // background: '#FAFAFB',
        background: 'transparent',
        // background: `url(${bg}), transparent no-repeat center`,
        // backgroundSze: 'cover',
        // width: '100%',
        // maxWidth: '100%',
        // margin: '0 auto',
        marginBottom: spacing(1),
        padding: spacing(3, 3, 0),
        // borderBottom: `1px solid ${palette.divider}`,
        // borderRadius: shape.borderRadius,
    },
    divider: {
        margin: spacing(3, 0),
    },
}));

function Title(props) {
    const { title, actions } = props;
    const classes = styles();

    if (!title) {
        return <></>;
    }

    return (
        <div>
            <Box display="flex" justifyContent="space-between" alignItems="center" className={classes.root}>
                <Typography variant="h4"><Box fontWeight={600}>{title}</Box></Typography>
                <Box>
                    {actions}
                </Box>
            </Box>
            {/* <Divider className={classes.divider} /> */}
        </div>
    );
}

Title.propTypes = propTypes;
Title.defaultProps = defaultProps;

export default Title;
